import {useCallback} from 'react';
import {useSelector, useStore} from 'react-redux';
import {toggleOption} from '~/common/fabric/reducers/giftingOptions/actions';
import {selectPhotosEnabled} from '~/common/fabric/reducers/giftingOptions/selectors';
import {CameraIcon} from '~library/svg/v2/CameraIcon';
import {OptionWrapper} from './OptionWrapper';

export const Photos = () => {
  const store = useStore();
  const isPhotosEnabled = useSelector(selectPhotosEnabled);
  const giftingOptions = useSelector(({giftingOptions: go}) => go);
  const togglePhotoSharing = useCallback(() => {
    store.dispatch(
      toggleOption(giftingOptions, 'event_option_enable_photo_sharing', !isPhotosEnabled)
    );
  }, [store, isPhotosEnabled, giftingOptions]);

  return (
    <OptionWrapper
      icon={<CameraIcon />}
      title="Shared photo album"
      subtitle="Allow you and your guests to upload photos to a shared album."
      onEdit={togglePhotoSharing}
      isActive={isPhotosEnabled}
      onRemove={togglePhotoSharing}
    />
  );
};
